import { render, staticRenderFns } from "./action-pause.vue?vue&type=template&id=5ec8a0d5&"
import script from "./action-pause.vue?vue&type=script&lang=js&"
export * from "./action-pause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports